import { useMemo } from 'react'

import {
    useMediaQuery,
    useTheme,
} from '@material-ui/core';

const DESKTOP_WIDTH = ['md','lg','xl']
const MOBILE_WIDTH = ['xs','sm',]

function useWidth() {
    const theme = useTheme();
    const keys = [...theme.breakpoints.keys].reverse();
    return (
      keys.reduce((output:any, key:any) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null) || "xs"
    );
  }

function useLayout() {
    const theme = useTheme();
    const allWidth = [...theme.breakpoints.keys] as const
    const width:typeof allWidth[number] = useWidth();

    const isDesktop = useMemo(()=>{
        return DESKTOP_WIDTH.includes(width)
    },[width])

    const isMobile = useMemo(()=>{
        return MOBILE_WIDTH.includes(width)
    },[width])

    const [isSmall,isMedium,isLarge] = useMemo(()=>{
      switch(width) {
        case "xs" : return [true,false,false]
        case "sm" : return [false,true,false]
        case "md" : return [false,true,false]
        case "lg" : return [false,false,true]
        case "xl" : return [false,false,true]
        default : return [false,false,false]
      }
    },[width])

    return ({
        isDesktop : isDesktop,
        isMobile : isMobile,
        rawLayout : width,
        isSmall : isSmall,
        isMedium : isMedium,
        isLarge : isLarge,
    })
    
}

export default useLayout